import { createClient } from "@supabase/supabase-js";
import { config } from "./config";

// Web variant of src/lib/supabase.ts (RN side).
// Uses default localStorage (no AsyncStorage adapter needed) and enables
// detectSessionInUrl so the OAuth redirect flow can pick the session out of
// the `#access_token=...` hash fragment Supabase returns to /auth/callback.
export const supabase = createClient(
  config.SUPABASE_URL,
  config.SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  }
);
